import { render } from "./CreatePageModal.vue?vue&type=template&id=e3662e1a&scoped=true"
import script from "./CreatePageModal.vue?vue&type=script&lang=js"
export * from "./CreatePageModal.vue?vue&type=script&lang=js"

import "./CreatePageModal.vue?vue&type=style&index=0&id=e3662e1a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3662e1a"]])

export default __exports__